import { motion } from "framer-motion";
import { Target, Eye } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLanguage } from "@/context/LanguageContext";

const MissionVision = () => {
  const { t } = useLanguage();

  const cards = [
    {
      icon: Target,
      label: t("mission.missionTitle"),
      desc: t("mission.missionDesc"),
      dark: true,
    },
    {
      icon: Eye,
      label: t("mission.visionTitle"),
      desc: t("mission.visionDesc"),
      dark: false,
    },
  ];

  return (
    <section className="relative py-24 md:py-36 bg-[#f8fff8]" data-testid="mission-vision-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <Reveal key={i} delay={i * 0.1}>
                <motion.div
                  whileHover={{ y: -6 }}
                  className={`relative h-full rounded-[30px] p-10 md:p-14 overflow-hidden border transition-shadow hover:shadow-2xl flex flex-col justify-between ${
                    c.dark
                      ? "bg-[#2d6a4f] border-[#2d6a4f] hover:shadow-[#2d6a4f]/25"
                      : "bg-white border-[#95d5b2]/40 hover:shadow-[#2d6a4f]/10"
                  }`}
                  data-testid={`mv-card-${i}`}
                >
                  <div className={`absolute -right-16 -top-16 h-52 w-52 rounded-full blur-3xl ${c.dark ? "bg-[#40916c]/50" : "bg-[#d8f3dc]/70"}`} />
                  <div className="relative">
                    <div className={`h-16 w-16 rounded-2xl flex items-center justify-center ${c.dark ? "bg-white/12 text-[#d8f3dc]" : "bg-[#d8f3dc] text-[#2d6a4f]"}`}>
                      <Icon size={28} strokeWidth={1.8} />
                    </div>
                    <p className={`eyebrow mt-8 ${c.dark ? "text-[#d8f3dc]" : "text-[#40916c]"}`}>{c.label}</p>
                    <h3 className={`font-display text-2xl md:text-3xl font-semibold tracking-tight mt-4 leading-relaxed ${c.dark ? "text-white" : "text-[#222222]"}`}>
                      {c.desc}
                    </h3>
                  </div>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
